"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_CONTRACT_STATUS_FILTER = void 0;
exports.ProjectSelector = ProjectSelector;
exports.CitySelector = CitySelector;
exports.EntitySelector = EntitySelector;
exports.OfferSelector = OfferSelector;
exports.FinancialAidProgrammeSelector = FinancialAidProgrammeSelector;
exports.FocusAreaSelector = FocusAreaSelector;
exports.FocusAreaSelectorPreloaded = FocusAreaSelectorPreloaded;
exports.ApplicationCallSelector = ApplicationCallSelector;
exports.ClientNeedSelector = ClientNeedSelector;
exports.ContractSelector = ContractSelector;
exports.ContractRangeSelector = ContractRangeSelector;
exports.ContractTypeSelector = ContractTypeSelector;
exports.UniquenessIcon = UniquenessIcon;
exports.CaseMultiplicityIcon = CaseMultiplicityIcon;
exports.CaseTypeSelector = CaseTypeSelector;
exports.MilestoneTypeSelector = MilestoneTypeSelector;
exports.OurLetterTemplateSelector = OurLetterTemplateSelector;
exports.PersonSelector = PersonSelector;
exports.PersonSelectorPreloaded = PersonSelectorPreloaded;
exports.RegisteringEditorSelector = RegisteringEditorSelector;
exports.CaseSelectMenuElement = CaseSelectMenuElement;
exports.MilestoneSelector = MilestoneSelector;
exports.SystemRoleSelector = SystemRoleSelector;
exports.LetterSelector = LetterSelector;
exports.SkillSelector = SkillSelector;
const react_1 = __importStar(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const react_bootstrap_typeahead_1 = require("react-bootstrap-typeahead");
require("react-bootstrap-typeahead/css/Typeahead.css");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
require("../../../Css/styles.css");
const MainSetupReact_1 = __importDefault(require("../../../React/MainSetupReact"));
const RepositoryReact_1 = __importDefault(require("../../../React/RepositoryReact"));
const FormContext_1 = require("../FormContext");
const react_hook_form_1 = require("react-hook-form");
const ContractsController_1 = require("../../../Contracts/ContractsList/ContractsController");
const CaseStatusFilter_1 = require("./CaseStatusFilter");
const StatusFilterMenuHeader_1 = require("./StatusFilterMenuHeader");
const GenericComponents_1 = require("./GenericComponents");
const ToolsForms_1 = require("../../../React/Tools/ToolsForms");
/**
 * Opakowanie selektora z opcjonalnym przyciskiem "+ Nowy…" (pick-or-create).
 * Gdy pojedynczy (single) selektor ma już wybraną wartość, przycisk znika,
 * a input dostaje pełną szerokość. Bez `onRequestCreate` renderuje sam selektor.
 */
function SelectorWithCreate({ selector, caption, name, multiple, onRequestCreate, wrapperClassName, }) {
    const { watch } = (0, FormContext_1.useFormContext)();
    const hideCreate = !onRequestCreate || (!multiple && !!watch(name));
    if (hideCreate) {
        return wrapperClassName ? react_1.default.createElement("div", { className: wrapperClassName }, selector) : react_1.default.createElement(react_1.default.Fragment, null, selector);
    }
    return (react_1.default.createElement("div", { className: `${wrapperClassName ? wrapperClassName + " " : ""}d-flex align-items-start gap-2` },
        react_1.default.createElement("div", { className: "flex-grow-1" }, selector),
        react_1.default.createElement(react_bootstrap_1.Button, { variant: "outline-success", className: "text-nowrap", onClick: onRequestCreate }, caption)));
}
/**
 * Komponent formularza wyboru projektu
 * @param showValidationInfo Czy wyświetlać informacje o walidacji - domyślnie true
 * @param name nazwa pola w formularzu - zostanie wysłane na serwer jako składowa obiektu FormData
 */
function ProjectSelector({ name = "_project", showValidationInfo = true, disabled = false, multiple = false, label = "Projekt", }) {
    const { formState: { errors }, } = (0, FormContext_1.useFormContext)();
    // ✅ Lokalna instancja repository tylko dla tego selectora
    const localRepository = (0, react_1.useMemo)(() => new RepositoryReact_1.default({
        actionRoutes: {
            getRoute: "projects",
            addNewRoute: "",
            editRoute: "",
            deleteRoute: "",
        },
        name: "projectSelector_temp",
    }), []);
    function renderOption(option) {
        const optionTyped = option;
        // ourId jest labelKey - zagwarantowane przez MyAsyncTypeahead
        const alias = (0, ToolsForms_1.safeGetFirstField)(optionTyped, ["alias"], "[Brak aliasu]");
        return (react_1.default.createElement("div", null,
            react_1.default.createElement("span", null, optionTyped.ourId),
            react_1.default.createElement("div", { className: "text-muted small text-wrap" }, alias)));
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_bootstrap_1.Form.Label, null, label),
        react_1.default.createElement(GenericComponents_1.MyAsyncTypeahead, { name: name, labelKey: "ourId", repository: localRepository, 
            //specialSerwerSearchActionRoute={'projects/' + MainSetup.currentUser.systemEmail}
            showValidationInfo: showValidationInfo, renderMenuItemChildren: renderOption, multiple: multiple })));
}
function CitySelector({ name = "_city", showValidationInfo = true, multiple = false, allowNew = false, onRequestCreate, }) {
    // ✅ Lokalna instancja repository tylko dla tego selectora
    const localRepository = (0, react_1.useMemo)(() => new RepositoryReact_1.default({
        actionRoutes: {
            getRoute: "cities",
            addNewRoute: "",
            editRoute: "",
            deleteRoute: "",
        },
        name: "citySelector_temp",
    }), []);
    function renderOption(option) {
        const typedOption = option;
        // name jest labelKey - zagwarantowane przez MyAsyncTypeahead
        const code = (0, ToolsForms_1.safeGetFirstField)(typedOption, ["code"], "");
        return (react_1.default.createElement("div", null,
            react_1.default.createElement("span", null, typedOption.name),
            react_1.default.createElement("span", { className: "text-muted small" },
                " ",
                code)));
    }
    const selector = (react_1.default.createElement(GenericComponents_1.MyAsyncTypeahead, { name: name, labelKey: "name", searchKey: "searchText", repository: localRepository, renderMenuItemChildren: renderOption, multiple: multiple, allowNew: allowNew, showValidationInfo: showValidationInfo }));
    return (react_1.default.createElement(SelectorWithCreate, { selector: selector, caption: "+ Nowe miasto", name: name, multiple: multiple, onRequestCreate: onRequestCreate }));
}
function EntitySelector({ name, showValidationInfo = true, multiple = false, allowNew = false, repository, onRequestCreate, }) {
    const { formState: { errors }, } = (0, FormContext_1.useFormContext)();
    // ✅ Lokalna instancja repository tylko dla tego selectora (lub użyj przekazanego)
    const localRepository = (0, react_1.useMemo)(() => {
        if (repository)
            return repository;
        return new RepositoryReact_1.default({
            actionRoutes: {
                getRoute: "entities",
                addNewRoute: "",
                editRoute: "",
                deleteRoute: "",
            },
            name: "entitySelector_temp",
        });
    }, [repository]);
    function renderOption(option, props) {
        const typedOption = option;
        // name jest labelKey - zagwarantowane przez MyAsyncTypeahead
        const shortName = (0, ToolsForms_1.safeGetFirstField)(typedOption, ["shortName"], "");
        const address = (0, ToolsForms_1.safeGetFirstField)(typedOption, ["address"], "[Brak adresu]");
        const taxNumber = (0, ToolsForms_1.safeGetFirstField)(typedOption, ["taxNumber"], "[Brak NIP]");
        return (react_1.default.createElement("div", null,
            react_1.default.createElement("span", null, typedOption.name),
            shortName ? react_1.default.createElement("div", { className: "text-muted small text-wrap" }, shortName) : null,
            react_1.default.createElement("div", { className: "text-muted small text-wrap" },
                address,
                " | ",
                taxNumber)));
    }
    const selector = (react_1.default.createElement(GenericComponents_1.MyAsyncTypeahead, { name: name, labelKey: "name", searchKey: "searchText", repository: localRepository, renderMenuItemChildren: renderOption, align: "left", multiple: multiple, allowNew: allowNew, showValidationInfo: showValidationInfo }));
    return (react_1.default.createElement(SelectorWithCreate, { selector: selector, caption: "+ Nowy podmiot", name: name, multiple: multiple, onRequestCreate: onRequestCreate, wrapperClassName: "entity-selector-wrapper" }));
}
function OfferSelector({ name = "_offer", showValidationInfo = true, multiple = false, readOnly = false, }) {
    const { formState: { errors }, } = (0, FormContext_1.useFormContext)();
    // ✅ Lokalna instancja repository tylko dla tego selectora
    const localRepository = (0, react_1.useMemo)(() => new RepositoryReact_1.default({
        actionRoutes: {
            getRoute: "offers",
            addNewRoute: "",
            editRoute: "",
            deleteRoute: "",
        },
        name: "offerSelector_temp",
    }), []);
    function renderOption(option) {
        const typedOption = option;
        // alias jest labelKey - zagwarantowane przez MyAsyncTypeahead
        const typeName = (0, ToolsForms_1.safeGetFirstField)(typedOption, ["_type.name"], "[Brak typu]");
        const cityName = (0, ToolsForms_1.safeGetFirstField)(typedOption, ["_city.name"], "");
        const deadline = (0, ToolsForms_1.safeGetFirstField)(typedOption, ["submissionDeadline"], "");
        const employerName = (0, ToolsForms_1.safeGetFirstField)(typedOption, ["employerName"], "[Brak pracodawcy]");
        return (react_1.default.createElement("div", null,
            react_1.default.createElement("span", null,
                typeName,
                " ",
                ` `,
                cityName,
                " ",
                ` | `,
                typedOption.alias,
                " ",
                ` | `,
                deadline),
            react_1.default.createElement("div", { className: "text-muted small text-wrap" }, employerName)));
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(GenericComponents_1.MyAsyncTypeahead, { name: name, labelKey: "alias", searchKey: "searchText", repository: localRepository, renderMenuItemChildren: renderOption, multiple: multiple, showValidationInfo: showValidationInfo, readOnly: readOnly })));
}
function FinancialAidProgrammeSelector({ name = "_financialAidProgramme", showValidationInfo = true, multiple = false, allowNew = false, repository, onRequestCreate, }) {
    const { formState: { errors }, } = (0, FormContext_1.useFormContext)();
    // ✅ Lokalna instancja repository tylko dla tego selectora (lub użyj przekazanego)
    const localRepository = (0, react_1.useMemo)(() => {
        if (repository)
            return repository;
        return new RepositoryReact_1.default({
            actionRoutes: {
                getRoute: "financialAidProgrammes",
                addNewRoute: "",
                editRoute: "",
                deleteRoute: "",
            },
            name: "financialAidProgrammeSelector_temp",
        });
    }, [repository]);
    function renderOption(option) {
        const optionTyped = option;
        return (react_1.default.createElement("div", null,
            react_1.default.createElement("span", null, optionTyped.name)));
    }
    const selector = (react_1.default.createElement(GenericComponents_1.MyAsyncTypeahead, { name: name, labelKey: "name", searchKey: "searchText", repository: localRepository, renderMenuItemChildren: renderOption, multiple: multiple, allowNew: allowNew, showValidationInfo: showValidationInfo }));
    return (react_1.default.createElement(SelectorWithCreate, { selector: selector, caption: "+ Nowy program", name: name, multiple: multiple, onRequestCreate: onRequestCreate }));
}
function FocusAreaSelector({ name = "_focusArea", showValidationInfo = true, multiple = false, allowNew = false, _financialAidProgramme, onRequestCreate, }) {
    const { formState: { errors }, } = (0, FormContext_1.useFormContext)();
    // ✅ Lokalna instancja repository tylko dla tego selectora
    const localRepository = (0, react_1.useMemo)(() => new RepositoryReact_1.default({
        actionRoutes: {
            getRoute: "focusAreas",
            addNewRoute: "",
            editRoute: "",
            deleteRoute: "",
        },
        name: "focusAreaSelector_temp",
    }), []);
    function renderOption(option) {
        const optionTyped = option;
        return (react_1.default.createElement("div", null,
            react_1.default.createElement("span", null, optionTyped.name)));
    }
    const selector = (react_1.default.createElement(GenericComponents_1.MyAsyncTypeahead, { name: name, labelKey: "name", searchKey: "searchText", contextSearchParams: {
            _financialAidProgramme,
        }, repository: localRepository, renderMenuItemChildren: renderOption, multiple: multiple, allowNew: allowNew, showValidationInfo: showValidationInfo }));
    return (react_1.default.createElement(SelectorWithCreate, { selector: selector, caption: "+ Nowe dzia\u0142anie", name: name, multiple: multiple, onRequestCreate: onRequestCreate }));
}
/**
 * Komponent formularza wyboru typu kontraktu
 * @param name nazwa pola w formularzu - zostanie wysłane na serwer jako składowa obiektu FormData (domyślnie '_type')
 * @param showValidationInfo czy pokazywać informacje o walidacji (domyślnie true)
 * @param required czy pole jest wymagane (walidacja) - domyślnie false
 */
function FocusAreaSelectorPreloaded({ repository, _financialAidProgramme, required = false, showValidationInfo = true, multiple = false, name = "_focusArea", }) {
    const { control, watch, setValue, formState: { errors }, } = (0, FormContext_1.useFormContext)();
    const [options, setOptions] = (0, react_1.useState)([]);
    const label = "Działanie";
    (0, react_1.useEffect)(() => {
        const fetchData = async () => {
            if (_financialAidProgramme)
                await repository.loadItemsFromServerPOST([{ _financialAidProgramme }]);
            else
                repository.clearData();
            setOptions(repository.items);
            setValue(name, multiple ? [] : null);
        };
        fetchData();
    }, [_financialAidProgramme]);
    function handleOnChange(selectedOptions, field) {
        const valueToBeSent = multiple ? selectedOptions : selectedOptions[0];
        setValue(name, valueToBeSent);
        field.onChange(valueToBeSent);
    }
    return (react_1.default.createElement(react_bootstrap_1.Form.Group, { controlId: name },
        react_1.default.createElement(react_bootstrap_1.Form.Label, null, label),
        react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(react_hook_form_1.Controller, { name: name, control: control, rules: { required: { value: required, message: "Wybierz działanie" } }, render: ({ field }) => (react_1.default.createElement(react_bootstrap_typeahead_1.Typeahead, { id: `${name}-controlled`, labelKey: "name", multiple: multiple, options: options, onChange: (items) => handleOnChange(items, field), selected: field.value ? (multiple ? field.value : [field.value]) : [], placeholder: "-- Wybierz dzia\u0142anie --", isValid: showValidationInfo ? !errors?.[name] : undefined, isInvalid: showValidationInfo ? !!errors?.[name] : undefined, renderMenuItemChildren: (option, props, index) => {
                        const optionTyped = option;
                        return (react_1.default.createElement("div", null,
                            react_1.default.createElement("span", null, optionTyped.alias),
                            react_1.default.createElement("div", { className: "text-muted small text-wrap" }, optionTyped.name)));
                    } })) }),
            react_1.default.createElement(GenericComponents_1.ErrorMessage, { errors: errors, name: name }))));
}
function ApplicationCallSelector({ name = "_applicationCall", showValidationInfo = true, multiple = false, allowNew = false, _financialAidProgramme, _focusArea, }) {
    const { formState: { errors }, } = (0, FormContext_1.useFormContext)();
    // ✅ Lokalna instancja repository tylko dla tego selectora
    const localRepository = (0, react_1.useMemo)(() => new RepositoryReact_1.default({
        actionRoutes: {
            getRoute: "applicationCalls",
            addNewRoute: "",
            editRoute: "",
            deleteRoute: "",
        },
        name: "applicationCallSelector_temp",
    }), []);
    function renderOption(option) {
        const optionTyped = option;
        // description jest labelKey - zagwarantowane przez MyAsyncTypeahead
        const endDate = (0, ToolsForms_1.safeGetFirstField)(optionTyped, ["endDate"], "");
        const status = (0, ToolsForms_1.safeGetFirstField)(optionTyped, ["status"], "");
        return (react_1.default.createElement("div", null,
            react_1.default.createElement("span", null, optionTyped.description),
            react_1.default.createElement("div", { className: "text-muted small text-wrap" },
                endDate,
                " ",
                status)));
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(GenericComponents_1.MyAsyncTypeahead, { name: name, labelKey: "description", searchKey: "searchText", contextSearchParams: {
                _financialAidProgramme,
                _focusArea,
            }, repository: localRepository, renderMenuItemChildren: renderOption, multiple: multiple, allowNew: allowNew, showValidationInfo: showValidationInfo })));
}
function ClientNeedSelector({ name = "_need", showValidationInfo = true, multiple = false, allowNew = false, }) {
    const { formState: { errors }, } = (0, FormContext_1.useFormContext)();
    // ✅ Lokalna instancja repository tylko dla tego selectora
    const localRepository = (0, react_1.useMemo)(() => new RepositoryReact_1.default({
        actionRoutes: {
            getRoute: "needs",
            addNewRoute: "",
            editRoute: "",
            deleteRoute: "",
        },
        name: "clientNeedSelector_temp",
    }), []);
    function renderOption(option) {
        const optionTyped = option;
        // name jest labelKey - zagwarantowane przez MyAsyncTypeahead
        const clientName = (0, ToolsForms_1.safeGetFirstField)(optionTyped, ["_client.name"], "[Brak klienta]");
        const status = (0, ToolsForms_1.safeGetFirstField)(optionTyped, ["status"], "");
        return (react_1.default.createElement("div", null,
            react_1.default.createElement("span", null, optionTyped.name),
            react_1.default.createElement("div", { className: "text-muted small text-wrap" },
                clientName,
                " | ",
                status)));
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(GenericComponents_1.MyAsyncTypeahead, { name: name, labelKey: "name", searchKey: "searchText", repository: localRepository, renderMenuItemChildren: renderOption, multiple: multiple, allowNew: allowNew, showValidationInfo: showValidationInfo })));
}
/** Domyślny filtr statusów kontraktów w selektorze: aktywne (bez 'Zakończony' i 'Archiwalny'). */
exports.DEFAULT_CONTRACT_STATUS_FILTER = [
    MainSetupReact_1.default.ContractStatuses.NOT_STARTED,
    MainSetupReact_1.default.ContractStatuses.IN_PROGRESS,
];
/**
 * Komponent formularza wyboru kontraktu z wyszukiwaniem asynchronicznym
 * Używa lokalnego repository aby nie kolidować z innymi komponentami
 */
function ContractSelector({ name = "_contract", showValidationInfo = true, multiple = false, typesToInclude = "all", _project, readOnly = false, defaultStatuses = exports.DEFAULT_CONTRACT_STATUS_FILTER, limit, }) {
    const { formState: { errors }, } = (0, FormContext_1.useFormContext)();
    // Filtrowanie statusów robi SERWER (lista jest doczytywana asynchronicznie i przycinana
    // limitem, więc filtr na kliencie ucinałby wyniki już po limicie). Pusty filtr = brak
    // warunku, czyli wszystkie statusy - spójnie z zachowaniem serwera.
    const [statusFilter, setStatusFilter] = (0, react_1.useState)([...defaultStatuses]);
    // ✅ Lokalna instancja repository tylko dla tego selectora
    const localRepository = (0, react_1.useMemo)(() => new RepositoryReact_1.default({
        actionRoutes: {
            getRoute: "contracts",
            addNewRoute: "",
            editRoute: "",
            deleteRoute: "",
        },
        name: "contractSelector_temp",
    }), []);
    function renderOption(option) {
        const optionTyped = option;
        const isOurContract = "ourId" in optionTyped;
        if (isOurContract) {
            const ourContract = optionTyped;
            const secondaryParts = [ourContract.alias, ourContract._ourType, ourContract.status].filter(Boolean);
            return (react_1.default.createElement("div", null,
                react_1.default.createElement("span", null, ourContract.ourId || "[Brak numeru]"),
                react_1.default.createElement("div", { className: "text-muted small text-wrap" }, secondaryParts.join(" | ") || "[Brak danych]")));
        }
        const otherContract = optionTyped;
        const contractorsLabel = (otherContract._contractors ?? []).map((contractor) => contractor.name).filter(Boolean).join(", ");
        const primaryParts = [otherContract.alias, contractorsLabel].filter(Boolean);
        const secondaryParts = [`${otherContract._type?.name || "[Brak typu]"} ${otherContract.number || "[Brak numeru]"}`.trim(), otherContract.status].filter(Boolean);
        return (react_1.default.createElement("div", null,
            react_1.default.createElement("span", null, primaryParts.join(" | ") || otherContract.name || "[Brak danych]"),
            react_1.default.createElement("div", { className: "text-muted small text-wrap" }, secondaryParts.join(" | ") || "[Brak danych]")));
    }
    function renderContractMenu(results, menuProps, state) {
        const contracts = results;
        return (
        // paddingTop: 0 usuwa górną szczelinę .dropdown-menu, w której przewijane
        // pozycje przebijałyby NAD sticky-nagłówkiem filtra statusów.
        react_1.default.createElement(react_bootstrap_typeahead_1.Menu, { ...menuProps, style: { ...(menuProps.style || {}), paddingTop: 0 } },
            react_1.default.createElement(StatusFilterMenuHeader_1.StatusFilterMenuHeader, { allStatuses: Object.values(MainSetupReact_1.default.ContractStatuses), selectedStatuses: statusFilter, onChange: setStatusFilter }),
            contracts.length === 0 && (react_1.default.createElement("div", { className: "px-3 py-2 text-muted small" }, state?.isLoading ? "Szukam…" : "Brak kontraktów.")),
            contracts.map((item, index) => (react_1.default.createElement(react_bootstrap_typeahead_1.MenuItem, { key: item.id, option: item, position: index }, renderOption(item))))));
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(GenericComponents_1.MyAsyncTypeahead, { name: name, labelKey: "_ourIdOrNumber_Name", searchKey: "searchText", contextSearchParams: {
                typesToInclude: typesToInclude,
                _project: _project,
                statuses: statusFilter,
                limit: limit,
            }, repository: localRepository, renderMenu: renderContractMenu, multiple: multiple, showValidationInfo: showValidationInfo, readOnly: readOnly })));
}
function ContractRangeSelector({ repository, showValidationInfo = true, multiple = true, name = "_contractRanges", onRequestCreate, }) {
    const { control, setValue, getValues, formState: { errors }, } = (0, FormContext_1.useFormContext)();
    const [options, setOptions] = (0, react_1.useState)([]);
    const label = "Zakresy";
    (0, react_1.useEffect)(() => {
        const fetchData = async () => {
            await repository.loadItemsFromServerPOST();
            setOptions(repository.items);
            const currentValue = getValues(name);
            if (multiple) {
                if (!Array.isArray(currentValue) || currentValue.length === 0) {
                    setValue(name, []);
                }
            }
            else {
                if (!currentValue) {
                    setValue(name, null);
                }
            }
        };
        fetchData();
    }, [repository, setValue, multiple, name]);
    const selector = (react_1.default.createElement(react_hook_form_1.Controller, { name: name, control: control, render: ({ field }) => {
            const formValue = (field.value || []);
            // Zakres utworzony inline nie zdążył trafić do `options` - bierzemy go
            // wtedy wprost z wartości formularza, żeby pozostał widoczny jako wybrany.
            const currentSelection = formValue
                .map((item) => {
                const itemId = item?._contractRange?.id ?? item?.id;
                return options.find((option) => option.id === itemId) ?? item?._contractRange ?? item;
            })
                .filter(Boolean);
            return (react_1.default.createElement(react_bootstrap_typeahead_1.Typeahead, { id: `${name}-controlled`, labelKey: "name", multiple: multiple, options: options, onChange: field.onChange, selected: currentSelection, placeholder: "-- Wybierz zakresy kontraktu --", isValid: showValidationInfo ? !errors?.[name] : undefined, isInvalid: showValidationInfo ? !!errors?.[name] : undefined, renderMenuItemChildren: (option, props, index) => {
                    const optionTyped = option;
                    return (react_1.default.createElement("div", null,
                        react_1.default.createElement("span", null, optionTyped.name),
                        react_1.default.createElement("div", { className: "text-muted small text-wrap" }, optionTyped.description)));
                } }));
        } }));
    return (react_1.default.createElement(react_bootstrap_1.Form.Group, { controlId: name },
        react_1.default.createElement(react_bootstrap_1.Form.Label, null, label),
        react_1.default.createElement(SelectorWithCreate, { selector: selector, caption: "+ Nowy zakres", name: name, multiple: multiple, onRequestCreate: onRequestCreate }),
        react_1.default.createElement(GenericComponents_1.ErrorMessage, { errors: errors, name: name })));
}
/**
 * Komponent formularza wyboru typu kontraktu
 * @param name nazwa pola w formularzu - zostanie wysłane na serwer jako składowa obiektu FormData (domyślnie '_type')
 * @param typesToInclude 'our' | 'other' | 'all' - jakie typy kontraktów mają być wyświetlane (domyślnie 'all')
 * @param showValidationInfo czy pokazywać informacje o walidacji (domyślnie true)
 * @param required czy pole jest wymagane (walidacja) - domyślnie false
 */
function ContractTypeSelector({ typesToInclude = "all", required = false, showValidationInfo = true, multiple = false, name = "_type", }) {
    const { control, watch, setValue, formState: { errors }, } = (0, FormContext_1.useFormContext)();
    const label = "Typ Kontraktu";
    const repository = MainSetupReact_1.default.contractTypesRepository;
    //tymczasowe, ale działa
    if (!repository) {
        return (react_1.default.createElement(react_bootstrap_1.Form.Group, { controlId: label },
            react_1.default.createElement(react_bootstrap_1.Form.Label, null, label),
            react_1.default.createElement(react_bootstrap_1.Form.Control, { placeholder: "Od\u015Bwie\u017C aby za\u0142adowa\u0107 typy", disabled: true })));
    }
    function makeoptions(repositoryDataItems) {
        const filteredItems = repositoryDataItems.filter((item) => {
            if (typesToInclude === "all")
                return true;
            if (typesToInclude === "our" && item.isOur)
                return true;
            if (typesToInclude === "other" && !item.isOur)
                return true;
            return false;
        });
        return filteredItems;
    }
    function handleOnChange(selectedOptions, field) {
        const valueToBeSent = multiple ? selectedOptions : selectedOptions[0];
        setValue(name, valueToBeSent);
        field.onChange(valueToBeSent);
    }
    return (react_1.default.createElement(react_bootstrap_1.Form.Group, { controlId: label },
        react_1.default.createElement(react_bootstrap_1.Form.Label, null, label),
        react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(react_hook_form_1.Controller, { name: name, control: control, rules: { required: { value: required, message: "Wybierz typ kontraktu" } }, render: ({ field }) => (react_1.default.createElement(react_bootstrap_typeahead_1.Typeahead, { id: `${label}-controlled`, labelKey: "name", multiple: multiple, options: makeoptions(repository.items), onChange: (items) => handleOnChange(items, field), selected: field.value ? (multiple ? field.value : [field.value]) : [], placeholder: "-- Wybierz typ --", isValid: showValidationInfo ? !errors?.[name] : undefined, isInvalid: showValidationInfo ? !!errors?.[name] : undefined, renderMenuItemChildren: (option, props, index) => {
                        const optionTyped = option;
                        return (react_1.default.createElement("div", null,
                            react_1.default.createElement("span", null, optionTyped.name),
                            react_1.default.createElement("div", { className: "text-muted small text-wrap" }, optionTyped.description)));
                    } })) }),
            react_1.default.createElement(GenericComponents_1.ErrorMessage, { errors: errors, name: name }))));
}
/**
 * Komponent formularza wyboru typu kontraktu
 * @param name nazwa pola w formularzu - zostanie wysłane na serwer jako składowa obiektu FormData (domyślnie '_type')
 * @param typesToInclude 'our' | 'other' | 'all' - jakie typy kontraktów mają być wyświetlane (domyślnie 'all')
 * @param showValidationInfo czy pokazywać informacje o walidacji (domyślnie true)
 * @param required czy pole jest wymagane (walidacja) - domyślnie false
 */
/**
 * Mała ikona obok typu sprawy informująca o krotności typu (zgodnie z regułą
 * `CaseType.isUniquePerMilestone`):
 * - `faLock` (kłódka) — typ UNIKALNY per kamień: max jedna sprawa tego typu, bez nazwy,
 * - `faLayerGroup` (warstwy) — typ WIELOKROTNY: wiele spraw tego typu odróżnianych nazwą.
 *
 * Dzięki temu użytkownik widzi w selektorze, czy dana sprawa jest "pojedyncza" czy jedną
 * z wielu — spójnie z polem "Nazwa sprawy", które pojawia się tylko dla typów wielokrotnych.
 */
/** Ogólna ikona unikalności — używana wszędzie tam, gdzie chcemy pokazać,
 *  czy dany typ jest unikalny (kłódka) czy wielokrotny (warstwy). */
function UniquenessIcon({ isUnique, title, }) {
    const defaultTitle = isUnique
        ? "Typ unikalny"
        : "Typ wielokrotny";
    return (react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: isUnique ? free_solid_svg_icons_1.faLock : free_solid_svg_icons_1.faLayerGroup, className: `ms-1 ${isUnique ? "text-secondary" : "text-primary"}`, size: "sm", title: title ?? defaultTitle }));
}
function CaseMultiplicityIcon({ caseType }) {
    if (!caseType)
        return null;
    return (react_1.default.createElement(UniquenessIcon, { isUnique: caseType.isUniquePerMilestone, title: caseType.isUniquePerMilestone
            ? "Typ unikalny — jedna sprawa tego typu na kamieniu (bez nazwy)"
            : "Typ wielokrotny — wiele spraw tego typu, odróżnianych nazwą" }));
}
function CaseTypeSelector({ milestoneType, filterFn, required = false, showValidationInfo = true, multiple = false, name = "_type", label = "Typ Sprawy", }) {
    const { control, watch, setValue, formState: { errors }, } = (0, FormContext_1.useFormContext)();
    const repository = ContractsController_1.caseTypesRepository;
    function makeoptions(repositoryDataItems) {
        let filteredItems = repositoryDataItems.filter((item) => {
            if (!milestoneType)
                return true;
            if (milestoneType.id === item._milestoneType.id)
                return true;
            return false;
        });
        if (filterFn)
            filteredItems = filteredItems.filter(filterFn);
        return filteredItems;
    }
    function handleOnChange(selectedOptions, field) {
        const valueToBeSent = multiple ? selectedOptions : selectedOptions[0];
        setValue(name, valueToBeSent);
        field.onChange(valueToBeSent);
    }
    return (react_1.default.createElement(react_bootstrap_1.Form.Group, { controlId: label },
        react_1.default.createElement(react_bootstrap_1.Form.Label, null, label),
        react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(react_hook_form_1.Controller, { name: name, control: control, rules: { required: { value: required, message: "Wybierz typ sprawy" } }, render: ({ field }) => (react_1.default.createElement(react_bootstrap_typeahead_1.Typeahead, { id: `${label}-controlled`, labelKey: "name", multiple: multiple, options: makeoptions(repository.items), onChange: (items) => handleOnChange(items, field), selected: field.value ? (multiple ? field.value : [field.value]) : [], placeholder: "-- Wybierz typ --", isValid: showValidationInfo ? !errors?.[name] : undefined, isInvalid: showValidationInfo ? !!errors?.[name] : undefined, renderMenuItemChildren: (option, props, index) => {
                        const myOption = option;
                        return (react_1.default.createElement("div", null,
                            react_1.default.createElement("span", null,
                                myOption.name,
                                react_1.default.createElement(CaseMultiplicityIcon, { caseType: myOption })),
                            react_1.default.createElement("div", { className: "text-muted small text-wrap" }, myOption.description)));
                    } })) }),
            react_1.default.createElement(GenericComponents_1.ErrorMessage, { errors: errors, name: name }))));
}
/**
 * Komponent formularza wyboru typu kontraktu
 * @param name nazwa pola w formularzu - zostanie wysłane na serwer jako składowa obiektu FormData (domyślnie '_type')
 * @param typesToInclude 'our' | 'other' | 'all' - jakie typy kontraktów mają być wyświetlane (domyślnie 'all')
 * @param showValidationInfo czy pokazywać informacje o walidacji (domyślnie true)
 * @param required czy pole jest wymagane (walidacja) - domyślnie false
 */
function MilestoneTypeSelector({ contractType, required = false, showValidationInfo = true, multiple = false, name = "_type", }) {
    const { control, watch, setValue, formState: { errors }, } = (0, FormContext_1.useFormContext)();
    const label = "Typ kamienia";
    const repository = ContractsController_1.milestoneTypesRepository;
    function makeOptions(repositoryDataItems) {
        const filteredItems = repositoryDataItems.filter((item) => {
            if (!contractType)
                return true;
            if (contractType.id === item._contractType.id)
                return true;
            return false;
        });
        return filteredItems;
    }
    function handleOnChange(selectedOptions, field) {
        const valueToBeSent = multiple ? selectedOptions : selectedOptions[0];
        setValue(name, valueToBeSent);
        field.onChange(valueToBeSent);
    }
    return (react_1.default.createElement(react_bootstrap_1.Form.Group, { controlId: label },
        react_1.default.createElement(react_bootstrap_1.Form.Label, null, label),
        react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(react_hook_form_1.Controller, { name: name, control: control, rules: { required: { value: required, message: "Wybierz typ kamienia" } }, render: ({ field }) => (react_1.default.createElement(react_bootstrap_typeahead_1.Typeahead, { id: `${label}-controlled`, labelKey: "name", multiple: multiple, options: makeOptions(repository.items), onChange: (items) => handleOnChange(items, field), selected: field.value ? (multiple ? field.value : [field.value]) : [], placeholder: "-- Wybierz typ --", isValid: showValidationInfo ? !errors?.[name] : undefined, isInvalid: showValidationInfo ? !!errors?.[name] : undefined, renderMenuItemChildren: (option, props, index) => {
                        const myOption = option;
                        return (react_1.default.createElement("div", null,
                            react_1.default.createElement("span", null, myOption.name),
                            react_1.default.createElement("div", { className: "text-muted small text-wrap" }, myOption.description)));
                    } })) }),
            react_1.default.createElement(GenericComponents_1.ErrorMessage, { errors: errors, name: name }))));
}
/**
 * Komponent formularza wyboru typu kontraktu
 * @param name nazwa pola w formularzu - zostanie wysłane na serwer jako składowa obiektu FormData (domyślnie '_type')
 * @param typesToInclude 'our' | 'other' | 'all' - jakie typy kontraktów mają być wyświetlane (domyślnie 'all')
 * @param showValidationInfo czy pokazywać informacje o walidacji (domyślnie true)
 * @param required czy pole jest wymagane (walidacja) - domyślnie false
 */
function OurLetterTemplateSelector({ showValidationInfo = true, _cases = [], }) {
    const { control, watch, setValue, formState: { errors }, } = (0, FormContext_1.useFormContext)();
    const name = "_template";
    const label = "Szablon pisma";
    const repository = MainSetupReact_1.default.documentTemplatesRepository;
    function makeoptions(templates) {
        const filteredTemplates = templates.filter((template) => {
            return (!template._contents.caseTypeId ||
                _cases.some((caseItem) => caseItem._type.id === template._contents.caseTypeId));
        });
        return filteredTemplates;
    }
    const options = makeoptions(repository.items);
    const selectedTemplate = watch(name);
    // klucz zamiast referencji: makeoptions tworzy nową tablicę co render, options w deps zapętliłoby efekt
    const optionsKey = options.map((option) => option.id).join(",");
    (0, react_1.useEffect)(() => {
        const selectedIsAvailable = selectedTemplate && options.some((option) => option.id === selectedTemplate.id);
        if (selectedTemplate && !selectedIsAvailable) {
            // wybór nieaktualny po zmianie spraw — wyczyść; kolejny przebieg efektu ustawi jedyną opcję
            setValue(name, undefined, { shouldValidate: true });
            return;
        }
        // gdy dostępny jest dokładnie jeden szablon, ustaw go automatycznie
        if (!selectedTemplate && options.length === 1) {
            setValue(name, options[0], { shouldValidate: true });
        }
    }, [selectedTemplate, optionsKey, setValue]);
    function handleOnChange(selectedOptions, field) {
        const valueToBeSent = selectedOptions[0];
        setValue(name, valueToBeSent);
        field.onChange(valueToBeSent);
    }
    return (react_1.default.createElement(react_bootstrap_1.Form.Group, { controlId: label },
        react_1.default.createElement(react_bootstrap_1.Form.Label, null, label),
        react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(react_hook_form_1.Controller, { name: name, control: control, render: ({ field }) => (react_1.default.createElement(react_bootstrap_typeahead_1.Typeahead, { id: `${label}-controlled`, labelKey: "name", multiple: false, options: options, onChange: (items) => handleOnChange(items, field), selected: field.value ? [field.value] : [], placeholder: "-- Wybierz szablon --", isValid: showValidationInfo ? !errors?.[name] : undefined, isInvalid: showValidationInfo ? !!errors?.[name] : undefined, renderMenuItemChildren: (option, props, index) => {
                        const myOption = option;
                        return (react_1.default.createElement("div", null,
                            react_1.default.createElement("span", null, myOption._nameContentsAlias),
                            react_1.default.createElement("div", { className: "text-muted small text-wrap" }, myOption.description)));
                    } })) }),
            react_1.default.createElement(GenericComponents_1.ErrorMessage, { errors: errors, name: name }))));
}
function PersonSelector({ name = "_person", showValidationInfo = true, multiple = false, allowNew = false, repository, onRequestCreate, }) {
    // ✅ Lokalna instancja repository tylko dla tego selectora
    const localRepository = (0, react_1.useMemo)(() => repository
        ? repository
        : new RepositoryReact_1.default({
            actionRoutes: {
                getRoute: "persons",
                addNewRoute: "",
                editRoute: "",
                deleteRoute: "",
            },
            name: "personSelector_temp",
        }), [repository]);
    function renderOption(option) {
        const typedOption = option;
        // _nameSurnameEmail jest labelKey - zagwarantowane przez MyAsyncTypeahead
        const entityName = (0, ToolsForms_1.safeGetFirstField)(typedOption, ["_entity.name"], "[Brak encji]");
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", null, typedOption._nameSurnameEmail),
            react_1.default.createElement("div", { className: "text-muted small text-wrap" },
                " ",
                entityName)));
    }
    const selector = (react_1.default.createElement(GenericComponents_1.MyAsyncTypeahead, { name: name, labelKey: "_nameSurnameEmail", searchKey: "searchText", repository: localRepository, renderMenuItemChildren: renderOption, multiple: multiple, allowNew: allowNew, showValidationInfo: showValidationInfo }));
    return (react_1.default.createElement(SelectorWithCreate, { selector: selector, caption: "+ Nowa osoba", name: name, multiple: multiple, onRequestCreate: onRequestCreate }));
}
/**
 * Komponent formularza wyboru osoby
 * @param label oznaczenie pola formularza
 * @param name nazwa pola w formularzu - zostanie wysłane na serwer jako składowa obiektu FormData
 */
function PersonSelectorPreloaded({ label, name, repository, multiple = false, showValidationInfo = true, }) {
    const { control, setValue, formState: { errors }, } = (0, FormContext_1.useFormContext)();
    function makeoptions(repositoryDataItems) {
        repositoryDataItems.map((item) => (item._nameSurname = `${item.name} ${item.surname}`));
        return repositoryDataItems;
    }
    function handleOnChange(selectedOptions, field) {
        const valueToBeSent = selectedOptions.length > 0 ? (multiple ? selectedOptions : selectedOptions[0]) : null;
        setValue(name, valueToBeSent);
        field.onChange(valueToBeSent);
    }
    function handleSelected(field) {
        const currentValue = (field.value ? (multiple ? field.value : [field.value]) : []);
        return makeoptions(currentValue);
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_bootstrap_1.Form.Label, null, label),
        react_1.default.createElement(react_hook_form_1.Controller, { name: name, control: control, render: ({ field }) => (react_1.default.createElement(react_bootstrap_typeahead_1.Typeahead, { id: `${label}-controlled`, labelKey: "_nameSurname", options: makeoptions(repository.items), onChange: (items) => handleOnChange(items, field), selected: handleSelected(field), placeholder: "-- Wybierz osob\u0119 --", multiple: multiple, isValid: showValidationInfo ? !errors?.[name] : undefined, isInvalid: showValidationInfo ? !!errors?.[name] : undefined })) }),
        react_1.default.createElement(GenericComponents_1.ErrorMessage, { errors: errors, name: name })));
}
function RegisteringEditorSelector({ label = "Osoba rejestrująca", name = "_editor", showValidationInfo = true, fetchRoute = "persons/registering-editors", }) {
    const { control, setValue, formState: { errors }, } = (0, FormContext_1.useFormContext)();
    const [editors, setEditors] = (0, react_1.useState)([]);
    const [isLoading, setIsLoading] = (0, react_1.useState)(true);
    (0, react_1.useEffect)(() => {
        const fetchRegisteringEditors = async () => {
            try {
                const response = await fetch(`${MainSetupReact_1.default.serverUrl}${fetchRoute}`, {
                    method: "GET",
                    credentials: "include",
                });
                if (response.ok) {
                    const data = await response.json();
                    setEditors(data);
                    // Ustaw domyślnie pierwszą osobę (zalogowany użytkownik)
                    if (data.length > 0) {
                        setValue(name, data[0], { shouldValidate: true });
                    }
                }
            }
            catch (error) {
                console.error("Błąd pobierania osób rejestrujących:", error);
            }
            finally {
                setIsLoading(false);
            }
        };
        fetchRegisteringEditors();
    }, [name, setValue, fetchRoute]);
    function makeOptions(items) {
        return items.map((item) => ({
            ...item,
            _nameSurname: `${item.name} ${item.surname}`,
        }));
    }
    function handleOnChange(selectedOptions, field) {
        const valueToBeSent = selectedOptions.length > 0 ? selectedOptions[0] : null;
        setValue(name, valueToBeSent, { shouldValidate: true });
        field.onChange(valueToBeSent);
    }
    function handleSelected(field) {
        if (!field.value)
            return [];
        const selected = field.value;
        // Typeahead wymaga labelKey (_nameSurname) na każdym elemencie, także w selected
        return [{
                ...selected,
                _nameSurname: `${selected.name} ${selected.surname}`,
            }];
    }
    if (isLoading) {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(react_bootstrap_1.Form.Label, null, label),
            react_1.default.createElement(react_bootstrap_1.Form.Control, { placeholder: "\u0141adowanie...", disabled: true })));
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_bootstrap_1.Form.Label, null, label),
        react_1.default.createElement(react_hook_form_1.Controller, { name: name, control: control, render: ({ field }) => (react_1.default.createElement(react_bootstrap_typeahead_1.Typeahead, { id: `${label}-controlled`, labelKey: "_nameSurname", options: makeOptions(editors), onChange: (items) => handleOnChange(items, field), selected: handleSelected(field), placeholder: "-- Wybierz osob\u0119 --", isValid: showValidationInfo ? !errors?.[name] : undefined, isInvalid: showValidationInfo ? !!errors?.[name] : undefined })) }),
        react_1.default.createElement(GenericComponents_1.ErrorMessage, { errors: errors, name: name })));
}
function groupByMilestone(cases) {
    return cases.reduce((groups, item) => {
        const key = item._parent?._FolderNumber_TypeName_Name ?? "Brak danych";
        if (!groups[key]) {
            groups[key] = [];
        }
        groups[key].push(item);
        return groups;
    }, {});
}
function renderCaseMenu(results, menuProps, state, groupedResults, milestoneNames, header) {
    let index = 0;
    const items = milestoneNames.map((milestoneName) => (react_1.default.createElement(react_1.Fragment, { key: milestoneName },
        index !== 0 && react_1.default.createElement(react_bootstrap_typeahead_1.Menu.Divider, null),
        react_1.default.createElement(react_bootstrap_typeahead_1.Menu.Header, null, milestoneName),
        groupedResults[milestoneName].map((item) => {
            const folderNumber = item._type?.folderNumber ?? "";
            const typeName = item._type?.name ?? "";
            const folderName = item._folderName ?? "";
            const menuItem = (react_1.default.createElement(react_bootstrap_typeahead_1.MenuItem, { key: index, option: item, position: index },
                folderNumber,
                " ",
                typeName,
                " ",
                folderName));
            index += 1;
            return menuItem;
        }))));
    // paddingTop: 0 usuwa domyślną górną szczelinę .dropdown-menu, w której przewijane
    // sprawy przebijałyby NAD sticky-nagłówkiem filtra statusów.
    return (react_1.default.createElement(react_bootstrap_typeahead_1.Menu, { ...menuProps, style: { ...(menuProps.style || {}), paddingTop: 0 } },
        header,
        milestoneNames.length === 0 && (react_1.default.createElement("div", { className: "px-3 py-2 text-muted small" }, "Brak spraw.")),
        items));
}
/** Token wybranej sprawy z ikoną ołówka pojawiającą się po kliknięciu (focus). */
function CaseEditableToken({ option, tokenProps, onEdit, }) {
    const [focused, setFocused] = (0, react_1.useState)(false);
    const caseItem = option;
    return (react_1.default.createElement(react_bootstrap_typeahead_1.Token, { onRemove: tokenProps.onRemove, option: option, tabIndex: tokenProps.tabIndex, disabled: tokenProps.disabled, onFocus: () => setFocused(true), onBlur: () => setFocused(false) },
        focused && (react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faPencil, size: "xs", className: "me-1", style: { cursor: "pointer" }, onMouseDown: (e) => e.preventDefault(), onClick: (e) => { e.stopPropagation(); onEdit(caseItem); }, title: "Edytuj spraw\u0119" })),
        caseItem._typeFolderNumber_TypeName_Number_Name));
}
/**
 * Pole wyboru sprawy z repozytorium pogrupowane po Milestonach
 * @param name nazwa pola formularza (musi być zgodna z nazwą pola w obiekcie)
 * @param repository repozytorium z którego pobierane są dane
 * @param multiple czy można wybrać wiele opcji
 * @param showValidationInfo czy wyświetlać informacje o błędzie walidacji (domyślnie true)
 * @param readOnly czy pole jest tylko do odczytu (domyślnie false)
 * @param _contract kontrakt do którego należy wybrana sprawa
 */
function CaseSelectMenuElement({ name = "_case", readonly = false, _contract, _offer, repository, onRequestEdit, showValidationInfo = true, multiple = true, onRequestCreate, refreshToken, }) {
    const [options, setOptions] = (0, react_1.useState)([]);
    // Domyślnie ukrywamy sprawy zamknięte; sprawy bez statusu (sprzed migracji) zawsze widoczne.
    const [statusFilter, setStatusFilter] = (0, react_1.useState)([...CaseStatusFilter_1.DEFAULT_CASE_STATUS_FILTER]);
    const { control, setValue, formState: { errors }, } = (0, FormContext_1.useFormContext)();
    const labelKey = "_typeFolderNumber_TypeName_Number_Name";
    const visibleOptions = options.filter((option) => !option.status || statusFilter.includes(option.status));
    (0, react_1.useEffect)(() => {
        const fetchData = async () => {
            if (_contract) {
                await repository.loadItemsFromServerPOST([
                    { contractId: _contract.id, milestoneParentType: "CONTRACT" },
                ]);
                setOptions(repository.items.map((item) => (0, ToolsForms_1.ensureLabelKey)(item, labelKey, `CaseSelectMenuElement[${name}]`)));
            }
            else if (_offer) {
                await repository.loadItemsFromServerPOST([{ offerId: _offer.id, milestoneParentType: "OFFER" }]);
                setOptions(repository.items.map((item) => (0, ToolsForms_1.ensureLabelKey)(item, labelKey, `CaseSelectMenuElement[${name}]`)));
            }
            else {
                repository.clearData();
                setOptions([]);
            }
        };
        fetchData();
    }, [_contract?.id, _offer?.id, labelKey, name, repository, refreshToken]);
    function handleOnChange(selectedOptions, field) {
        // Przy pustym wyborze wysyłamy null/[] (NIE undefined) — react-hook-form traktuje
        // setValue(undefined) jako brak zmiany i nie czyści pola kontrolowanego, przez co
        // Typeahead odbija kasowanie. Spójne z MyAsyncTypeahead.
        const valueToBeSent = selectedOptions.length > 0 ? (multiple ? selectedOptions : selectedOptions[0]) : multiple ? [] : null;
        setValue(name, valueToBeSent);
        field.onChange(valueToBeSent);
    }
    function getValidatedSelected(value) {
        if (!value) {
            return [];
        }
        const selectedValues = multiple ? value : [value];
        return selectedValues.map((item) => (0, ToolsForms_1.ensureLabelKey)(item, labelKey, `CaseSelectMenuElement[${name}]`));
    }
    const selector = (react_1.default.createElement(react_hook_form_1.Controller, { name: name, control: control, render: ({ field }) => (react_1.default.createElement(react_bootstrap_typeahead_1.Typeahead, { id: `${name}-typeahead`, labelKey: labelKey, multiple: multiple, options: visibleOptions, onChange: (items) => handleOnChange(items, field), renderMenu: (results, menuProps, state) => {
                const groupedResults = groupByMilestone(results);
                const milestoneNames = Object.keys(groupedResults).sort();
                const header = (react_1.default.createElement(CaseStatusFilter_1.CaseStatusFilterMenuHeader, { selectedStatuses: statusFilter, onChange: setStatusFilter }));
                return renderCaseMenu(results, menuProps, state, groupedResults, milestoneNames, header);
            }, selected: getValidatedSelected(field.value), placeholder: "-- Wybierz spraw\u0119 --", isValid: showValidationInfo ? !errors?.[name] : undefined, isInvalid: showValidationInfo ? !!errors?.[name] : undefined, renderMenuItemChildren: (option, props, index) => {
                const myOption = option;
                return (react_1.default.createElement("div", null,
                    react_1.default.createElement("span", null,
                        myOption._typeFolderNumber_TypeName_Number_Name,
                        react_1.default.createElement(CaseMultiplicityIcon, { caseType: myOption._type })),
                    react_1.default.createElement("div", { className: "text-muted small text-wrap" }, myOption.description)));
            }, renderToken: onRequestEdit ? (option, tokenProps, idx) => (react_1.default.createElement(CaseEditableToken, { key: idx, option: option, tokenProps: tokenProps, onEdit: onRequestEdit })) : undefined })) }));
    // Bez `onRequestCreate` zachowanie jest IDENTYCZNE jak dotychczas (sam Typeahead z filtrem
    // statusów w menu), więc wszystkie istniejące call-site pozostają nietknięte.
    if (!onRequestCreate)
        return selector;
    return (react_1.default.createElement("div", { className: "d-flex align-items-start gap-2" },
        react_1.default.createElement("div", { className: "flex-grow-1" }, selector),
        react_1.default.createElement(react_bootstrap_1.Button, { variant: "outline-success", className: "text-nowrap", disabled: readonly, onClick: onRequestCreate }, "+ Nowa sprawa")));
}
/**
 * Pole wyboru Kamienia milowego (Milestone) dla danego kontraktu.
 * Kamień milowy jest rodzicem Sprawy (`Case._parent`), więc selektor jest potrzebny
 * przy inline tworzeniu Sprawy w piśmie.
 *
 * Wzorowane na CaseSelectMenuElement, ale:
 * - single-select (Sprawa ma dokładnie jednego rodzica),
 * - używa WŁASNEJ lokalnej instancji repository z sufiksem `_temp` (useMemo) — nie
 *   przekazujemy repository przez propsy, aby nie zanieczyszczać globalnych repo.
 *
 * @param name nazwa pola formularza (domyślnie "_parent" — zgodnie z `Case._parent`)
 * @param _contract kontrakt, dla którego ładowane są kamienie milowe
 * @param readOnly czy pole jest tylko do odczytu (domyślnie false)
 * @param showValidationInfo czy wyświetlać informacje o walidacji (domyślnie true)
 */
function MilestoneSelector({ name = "_parent", _contract, _offer, readOnly = false, showValidationInfo = true, onRequestCreate, onOptionsLoaded, }) {
    const [options, setOptions] = (0, react_1.useState)([]);
    const { control, setValue, formState: { errors }, } = (0, FormContext_1.useFormContext)();
    const labelKey = "_FolderNumber_TypeName_Name";
    // ✅ Lokalna instancja repository tylko dla tego selektora (sufiks `_temp`)
    const localRepository = (0, react_1.useMemo)(() => new RepositoryReact_1.default({
        actionRoutes: {
            getRoute: "milestones",
            addNewRoute: "",
            editRoute: "",
            deleteRoute: "",
        },
        name: "milestoneSelector_temp",
    }), []);
    (0, react_1.useEffect)(() => {
        const fetchData = async () => {
            if (_contract?.id) {
                // Backend `/milestones` czyta `orConditions` (warunki AND/OR) oraz typ rodzica:
                // top-level `parentType` albo `milestoneParentType` z pierwszego warunku
                // (domyślnie "CONTRACT"). Kształt zapytania spójny z CaseSelectMenuElement.
                await localRepository.loadItemsFromServerPOST([
                    { contractId: _contract.id, milestoneParentType: "CONTRACT" },
                ]);
                setOptions(localRepository.items.map((item) => (0, ToolsForms_1.ensureLabelKey)(item, labelKey, `MilestoneSelector[${name}]`)));
                onOptionsLoaded?.(localRepository.items.length);
            }
            else if (_offer?.id) {
                // Kamienie oferty: typ rodzica podajemy w warunku (patrz komentarz wyżej).
                await localRepository.loadItemsFromServerPOST([
                    { offerId: _offer.id, milestoneParentType: "OFFER" },
                ]);
                setOptions(localRepository.items.map((item) => (0, ToolsForms_1.ensureLabelKey)(item, labelKey, `MilestoneSelector[${name}]`)));
                onOptionsLoaded?.(localRepository.items.length);
            }
            else {
                localRepository.clearData();
                setOptions([]);
                onOptionsLoaded?.(0);
            }
        };
        fetchData();
    }, [_contract, _offer, labelKey, name, localRepository]);
    function handleOnChange(selectedOptions, field) {
        const valueToBeSent = selectedOptions[0];
        setValue(name, valueToBeSent);
        field.onChange(valueToBeSent);
    }
    function getValidatedSelected(value) {
        if (!value) {
            return [];
        }
        return [(0, ToolsForms_1.ensureLabelKey)(value, labelKey, `MilestoneSelector[${name}]`)];
    }
    return (react_1.default.createElement(react_bootstrap_1.Form.Group, { controlId: name },
        react_1.default.createElement(react_bootstrap_1.Form.Label, null, "Kamie\u0144 milowy"),
        react_1.default.createElement(react_hook_form_1.Controller, { name: name, control: control, render: ({ field }) => (react_1.default.createElement(react_bootstrap_typeahead_1.Typeahead, { id: `${name}-typeahead`, labelKey: labelKey, multiple: false, disabled: readOnly, options: options, onChange: (items) => handleOnChange(items, field), selected: getValidatedSelected(field.value), placeholder: "-- Wybierz kamie\u0144 milowy --", isValid: showValidationInfo ? !errors?.[name] : undefined, isInvalid: showValidationInfo ? !!errors?.[name] : undefined, renderMenuItemChildren: (option) => {
                    const myOption = option;
                    return (react_1.default.createElement("div", null,
                        react_1.default.createElement("span", null, myOption._FolderNumber_TypeName_Name),
                        myOption.description ? (react_1.default.createElement("div", { className: "text-muted small text-wrap" }, myOption.description)) : null));
                } })) }),
        react_1.default.createElement(GenericComponents_1.ErrorMessage, { name: name, errors: errors })));
}
function SystemRoleSelector({ name = "systemRoleId", showValidationInfo = true }) {
    const { control, formState: { errors }, } = (0, FormContext_1.useFormContext)();
    const systemRolesOptions = Object.values(MainSetupReact_1.default.SystemRoles);
    return (react_1.default.createElement(react_bootstrap_1.Form.Group, { controlId: name },
        react_1.default.createElement(react_bootstrap_1.Form.Label, null, "Rola w systemie"),
        react_1.default.createElement(react_hook_form_1.Controller, { name: name, control: control, render: ({ field }) => {
                const selected = systemRolesOptions.filter((r) => r.id === Number(field.value));
                return (react_1.default.createElement(react_bootstrap_typeahead_1.Typeahead, { id: `${name}-typeahead`, labelKey: "systemName", options: systemRolesOptions, selected: selected, onChange: (items) => {
                        const item = items[0];
                        field.onChange(item ? item.id : "");
                    }, placeholder: "-- Wybierz rol\u0119 --", isValid: showValidationInfo ? !errors?.[name] : undefined, isInvalid: !!errors?.[name], renderMenuItemChildren: (option) => {
                        const role = option;
                        return (react_1.default.createElement("div", null,
                            react_1.default.createElement("span", null, role.systemName),
                            react_1.default.createElement("div", { className: "text-muted small text-wrap" }, role.description)));
                    } }));
            } }),
        react_1.default.createElement(GenericComponents_1.ErrorMessage, { name: name, errors: errors })));
}
/**
 * Komponent formularza do wyboru istniejącego pisma w ramach danego kontraktu.
 * Po wybraniu pisma, w formularzu ustawiana jest wartość jego numeru.
 * Uwaga: Używa własnej instancji repository, aby nie kolidować z głównym repo w FilterableTable.
 */
function LetterSelector({ name, label, _contract, showValidationInfo = true }) {
    const { control, setValue, formState: { errors }, } = (0, FormContext_1.useFormContext)();
    const [options, setOptions] = (0, react_1.useState)([]);
    const [isOpen, setIsOpen] = (0, react_1.useState)(false);
    // ✅ Lokalna instancja repository tylko dla tego selectora
    const localRepository = (0, react_1.useMemo)(() => new RepositoryReact_1.default({
        actionRoutes: {
            getRoute: "contractsLetters",
            addNewRoute: "",
            editRoute: "",
            deleteRoute: "",
        },
        name: "letterSelector_temp",
    }), []);
    (0, react_1.useEffect)(() => {
        const fetchData = async () => {
            if (_contract?.id) {
                await localRepository.loadItemsFromServerPOST([{ contractId: _contract.id }]);
                setOptions(localRepository.items);
            }
            else {
                setOptions([]);
            }
        };
        fetchData();
    }, [_contract, localRepository]);
    function normalizeComparableValue(value) {
        if (value === null || value === undefined)
            return "";
        return String(value).trim();
    }
    function handleOnChange(selectedOptions, field) {
        const selectedLetter = selectedOptions[0];
        const valueToSet = selectedLetter?.number || "";
        setValue(name, valueToSet);
        field.onChange(valueToSet);
    }
    return (react_1.default.createElement(react_bootstrap_1.Form.Group, { controlId: name },
        react_1.default.createElement(react_bootstrap_1.Form.Label, null, label),
        react_1.default.createElement(react_hook_form_1.Controller, { name: name, control: control, render: ({ field }) => {
                const normalizedFieldValue = normalizeComparableValue(field.value);
                const currentSelection = options.find((option) => normalizeComparableValue(option.number) === normalizedFieldValue);
                return (react_1.default.createElement(react_bootstrap_typeahead_1.Typeahead, { id: `${name}-typeahead`, labelKey: (option) => (option.number != null ? String(option.number) : ""), options: options, onChange: (selected) => {
                        handleOnChange(selected, field);
                        setIsOpen(false);
                    }, selected: currentSelection ? [currentSelection] : [], placeholder: "-- Wybierz pismo z listy --", isValid: showValidationInfo ? !errors?.[name] : undefined, isInvalid: showValidationInfo ? !!errors?.[name] : undefined, open: isOpen, onFocus: () => setIsOpen(true), onBlur: () => setTimeout(() => setIsOpen(false), 150), renderMenuItemChildren: (option) => (react_1.default.createElement("div", null,
                        react_1.default.createElement("span", null, option.number),
                        react_1.default.createElement("div", { className: "text-muted small text-wrap" }, option.description))) }));
            } }),
        react_1.default.createElement(GenericComponents_1.ErrorMessage, { errors: errors, name: name })));
}
function SkillSelector({ name = "_skills", multiple = true, showValidationInfo = false, label = "Specjalizacje", repository, }) {
    const { setValue, control, formState: { errors }, } = (0, FormContext_1.useFormContext)();
    const [options, setOptions] = (0, react_1.useState)([]);
    const localRepository = (0, react_1.useMemo)(() => repository
        ? repository
        : new RepositoryReact_1.default({
            actionRoutes: {
                getRoute: "v2/skills/search",
                addNewRoute: "",
                editRoute: "",
                deleteRoute: "",
            },
            name: "skillSelector_temp",
        }), [repository]);
    (0, react_1.useEffect)(() => {
        const fetchData = async () => {
            await localRepository.loadItemsFromServerPOST([]);
            setOptions(localRepository.items);
        };
        fetchData();
    }, [localRepository]);
    function handleOnChange(selected, field) {
        const valueToBeSent = multiple ? selected : selected[0];
        setValue(name, valueToBeSent);
        setValue("skillIds", selected.map((s) => s.id));
        field.onChange(valueToBeSent);
    }
    function getSelectedValue(fieldValue) {
        if (multiple) {
            return fieldValue || [];
        }
        if (fieldValue && typeof fieldValue === "object") {
            return [fieldValue];
        }
        return [];
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_bootstrap_1.Form.Label, null, label),
        react_1.default.createElement(react_hook_form_1.Controller, { name: name, control: control, render: ({ field }) => (react_1.default.createElement(react_bootstrap_typeahead_1.Typeahead, { id: `${name}-typeahead`, labelKey: "name", multiple: multiple, options: options, onChange: (selected) => handleOnChange(selected, field), selected: getSelectedValue(field.value), placeholder: multiple ? "-- Wybierz specjalizacje --" : "-- Wybierz specjalizacje --", isValid: showValidationInfo ? !errors?.[name] : undefined, isInvalid: showValidationInfo ? !!errors?.[name] : undefined, renderMenuItemChildren: (option) => {
                    const skill = option;
                    return (react_1.default.createElement("div", null,
                        react_1.default.createElement("span", null, skill.name),
                        react_1.default.createElement("div", { className: "text-muted small text-wrap" }, skill.description || "Brak opisu")));
                } })) })));
}
